module.exports = __webpack_public_path__ + "img/textE.40d1d7a2.png";